import { userHasResourceAccess } from '../../common/methods'
import { mapGetters } from 'vuex'
import { ROLEACTIONCODE, RESOURCENAMES } from '../../common/constants'

// a resuable mixin that allow to check user's access on the resources
export const accessControlMixin ={
    data() {
        return {
          RESOURCENAMES: RESOURCENAMES,
          ROLEACTIONCODE: ROLEACTIONCODE
        };
      },
      computed: {
        ...mapGetters(['getUserLoggedIn','getUserPermissions']),
      },
      methods: {
        userHasResourceAccess (uri, action = ROLEACTIONCODE.READ){
            return userHasResourceAccess(this.getUserPermissions, uri, action)
          }
      }
}